import { Download } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { cloneDeep, concat, get, isArray, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecord from 'src/lib/api/GetRecord';
import GetRecords from 'src/lib/api/GetRecords';
import POP_LEVEL from 'src/lib/api/Populations.json';
import { APIS, METHOD_POST } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ART_DER_EIGENLEISTUNG,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	PARTNER_DATEN_NICHT_ERFASST,
	PLATZHALTER_TEXT,
	TEMPLATES_FUNKTION_BESCHREIBUNG,
} from 'src/lib/constants/constant';
import { TEMPLATES_SERVICE_CLIENT_ID, TEMPLATES_SERVICE_PASSWORD, TEMPLATES_SERVICE_SERVER_ID, TEMPLATES_URL } from 'src/lib/constants/url';
import { FormStrucItem } from 'src/lib/types/types';
import {
	ForceTrue,
	GetMaxDecimalValidation,
	GetMinMaxDecimalValidation,
	GetMinMaxIntValidation,
	GetTextboxValidation,
	Required,
} from 'src/lib/validation/ValidationTypes';
import PositionLiegtNichtVor from 'src/pages/private/online-antrag/antrag-components/PositionLiegtNichtVor';
import { InhaltTrenner, InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import {
	addIndexesToPath,
	checkReadOnlyInUeberarbeitung,
	enumT,
	getOptionsFromRes,
	isTrue,
	removeDataKeys,
	removeNullDeep,
	transformValues,
} from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasicLeistungsGruppeFilter,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
} from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenpositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import LeistungsGruppeSchema from 'src/lib/paths/leistungsgruppe_FULL_Paths.json';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
const LG_P = LeistungsGruppeSchema.attributes;
const P = AntragSchema.attributes;
const KP_P = KostenpositionSchema.attributes;

const PersonalkostenAntragKreativwirtschaft: FC<{ kostentraeger: string; unternehmenId?: number; hasComment?: boolean }> = ({
	kostentraeger,
	unternehmenId,
	hasComment,
}) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);
	const [leistungsgruppe, setLeistungsgruppe] = useState([]);
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddPersonalkosten = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Personalkosten, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Ausgabe,
			KOSTEN_ARTEN.Personalkosten,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(application, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeletePersonalKosten = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};
	const handleDownloadFunktionBeschreibung = async (id: number, name: string) => {
		const templateUrl = TEMPLATES_URL + TEMPLATES_FUNKTION_BESCHREIBUNG.default;
		await saveApplication(false, application, false);

		let res = await GetRecord(APIS.Kostenposition, id, POP_LEVEL.kostenposition.FULL);
		const enumTranslatedData = transformValues(res, enumT);

		// Convert the response object to a JSON string
		let jsonString = JSON.stringify(enumTranslatedData);
		// Create a Blob from the JSON string
		let jsonBlob = new Blob([jsonString], { type: 'application/json' });
		let pdfData = new FormData();
		pdfData.append('data', jsonBlob, 'antrag_template_daten.json');
		let pdfRes = await fetch(templateUrl, {
			method: METHOD_POST,
			headers: {
				Authorization: 'Basic ' + btoa(TEMPLATES_SERVICE_PASSWORD),
				'X-Server-Id': TEMPLATES_SERVICE_SERVER_ID,
				'X-Client-Id': TEMPLATES_SERVICE_CLIENT_ID,
			},
			body: pdfData,
		});
		if (pdfRes) {
			const blob = await pdfRes.blob();
			const objectUrl = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = `Funktionbeschreibung_${name}.pdf`;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(objectUrl);
		}
	};

	// Fetch leistungsgruppe
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = getBasicLeistungsGruppeFilter(application);
				let res = await GetRecords(APIS.Leistungsgruppe, [], filter);
				setLeistungsgruppe(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Leistungsgruppe ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	// Fetch KostenKategories
	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Ausgabe,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Personalkosten,
						Allgemein_Antragsformular: { $contains: get(application, P.Allgemein_Antragsformular.path) },
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategorie ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />

			<PositionLiegtNichtVor kostenPosition={KOSTEN_POSITION.Ausgabe} kostenArt={KOSTEN_ARTEN.Personalkosten} updatedReadOnly={updatedReadOnly} />

			{/* eslint-disable-next-line array-callback-return */}
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					const nameDerBeschaeftigten = get(
						ele,
						KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Name_Desder_Beschaeftigten.path,
						'',
					);
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Personalkosten ${get(ele, KP_P.Allgemein_Bezeichnung.path) ? '| ' + get(ele, KP_P.Allgemein_Bezeichnung.path) : ''}`}
							onDelete={() => handleDeletePersonalKosten(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapPersonalKosten(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>
							<Grid2 spacing={6} container>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalKosten(formStrucSpalte1Kategorie(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapPersonalKosten(formStrucSpalte2Person(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
							</Grid2>

							<Grid2 spacing={6} container>
								<Grid2 sm={6} sx={{ paddingTop: 0 }}>
									<CreateForm
										formStruc={mapPersonalKosten(formStrucKalkulationSpalte1(ele, leistungsgruppe, kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
										api={APIS.Kostenposition}
										size='small'
									/>
								</Grid2>
								<Grid2 sm={6} sx={{ paddingTop: 0 }}>
									<Box sx={{ mt: '2rem' }}>
										<CreateTable
											formStruc={mapPersonalKosten(formStrucKalkulationSpalte2(ele, i), i)}
											formValues={application}
											updateFormValuesFunc={setApplicationProperty}
											readOnly={updatedReadOnly}
											api={APIS.Kostenposition}
											size='small'
										/>
									</Box>
								</Grid2>
							</Grid2>

							<CreateForm
								formStruc={mapPersonalKosten(formStrucFunktionen(ele), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
								size='small'
							/>
							{(
								get(ele, KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path) ===
									ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal ||
								get(ele, KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path) ===
									ART_DER_EIGENLEISTUNG.BareEigenleistung
							) ?
								<>
									<InhaltTrenner />
									<InhaltWrapper>
										<Typography variant='h4' component={'h2'}>
											Funktionbeschreibung
										</Typography>

										<Typography> Laden Sie hier die Funktionsbeschreibung als PDF runter:</Typography>
										<Button
											variant={'outlined'}
											startIcon={<Download />}
											onClick={() => handleDownloadFunktionBeschreibung(get(ele, 'id'), nameDerBeschaeftigten)}
											sx={{ maxWidth: 'fit-content' }}
										>
											Funktionbeschreibung für {nameDerBeschaeftigten}
										</Button>
									</InhaltWrapper>

									<InhaltTrenner marginTop='2rem' />
									<InhaltWrapper>
										<Typography sx={{ fontWeight: '500' }}>
											Bitte laden Sie anschließend das unterschriebene Dokument über das Uploadfeld hoch:
										</Typography>
									</InhaltWrapper>
									<Box sx={{ mt: '1rem' }}>
										<CreateForm
											formStruc={mapPersonalKosten(formStrucUpload(ele), i)}
											formValues={application}
											updateFormValuesFunc={setApplicationProperty}
											readOnly={updatedReadOnly}
											api={APIS.Kostenposition}
											size='small'
										/>
									</Box>
								</>
							:	null}
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} onClick={handleAddPersonalkosten} disabled={updatedReadOnly}>
					Personalkosten hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};

export default PersonalkostenAntragKreativwirtschaft;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucSpalte1Kategorie = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	const options = getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung');
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'enumeration',
					options: options,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	if (isArray(options) && options.length === 1) {
		struc = [
			{
				fields: [
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Name_Desder_Beschaeftigten,
						label: 'Name', // Das gleiche Feld wird in der Funktion formStrucSpalte2Person verwendet.
						// Das Feld kommt zweimal vor, weil das Feld wird abhängig von Kostenkategorie entweder in der erste Spalte oder in der zweite Spalte angezeigt wird.
					},
				],
				userProps: { columnToDivide: 1 },
			},
		];
	}
	return struc;
};
const formStrucSpalte2Person = (kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	const options = getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung');
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
						.Kreativwirtschaft_Name_Desder_Beschaeftigten,
					label: 'Name',
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	if (isArray(options) && options.length === 1) {
		struc = [];
	}
	return struc;
};

const formStrucKalkulationSpalte1 = (currentKostenPosition: any, leistungsGruppen?: any[], kostenKategorie?: any[]) => {
	const kategorieOptions = kostenKategorie || [];
	const options = getOptionsFromRes(kategorieOptions, 'Allgemein_Bezeichnung');
	const leistungsgruppeOption = leistungsGruppen || [];
	const leistungsgruppeFiltered = leistungsgruppeOption.filter((ele: any) => !isTrue(get(ele, LG_P.Allgemein_ist_Mindestlohn.path)));
	const selectedEigenLeitung = get(
		currentKostenPosition,
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path,
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
						.Kreativwirtschaft_Art_Der_Eigenleistung,
					...(isArray(options) && options.length === 1 ? { label: 'Kostenkategorie' } : {}),
				},
				...((
					selectedEigenLeitung === ART_DER_EIGENLEISTUNG.BareEigenleistung ||
					selectedEigenLeitung === ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal
				) ?
					[
						{
							...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Leistungsgruppe,
							type: 'enumeration',
							options: getOptionsFromRes(leistungsgruppeFiltered, 'Allgemein_Bezeichnung'),
						},
					]
				:	[]),
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucKalkulationSpalte2 = (currentKostenPosition: any, _i: number) => {
	let struc: FormStrucItem[] = [];
	const selectedEigenLeitung = get(
		currentKostenPosition,
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path,
	);

	const ErrechneteMaxEinsatzstunden = Number(
		get(
			currentKostenPosition,
			KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Errechnete_Max_Einsatzstunden_Im_Jahr_Der_Bewilligung.path,
			'0',
		),
	);

	if (selectedEigenLeitung === ART_DER_EIGENLEISTUNG.UnbareEigenleistung) {
		struc = [
			// Mindestlohn
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe.path,
						label: 'Mindestlohn',
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe,
						format: 'currency',
						disabled: true,
					},
				],
				userProps: { direction: 'column', columnToDivide: 1 },
			},
			// Anzahl der geplanten Stunden im Projekt
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Anzahl_Der_Geplanten_Stunden_Im_Projekt.path,
						label: 'Anzahl der geplanten Stunden im Projekt (insgesamt)',
					},
					P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
						.Anzahl_Der_Geplanten_Stunden_Im_Projekt,
				],
				userProps: { direction: 'column', columnToDivide: 1 },
			},
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
						format: 'currency',
						disabled: true,
					},
				],
				userProps: { direction: 'column', columnToDivide: 1 },
			},
		];
	} else if (selectedEigenLeitung === ART_DER_EIGENLEISTUNG.BareEigenleistung) {
		struc = [
			//Stundensatz lt. Entgeltgruppe
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe,
						disabled: true,
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Anzahl der geplanten Stunden im Projekt
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Anzahl_Der_Geplanten_Stunden_Im_Projekt.path,
						label: 'Anzahl der geplanten Stunden im Projekt (insgesamt)',
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Anzahl_Der_Geplanten_Stunden_Im_Projekt,
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Geplante Gesamtsumme (€)
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
						format: 'currency',
						disabled: true,
					},
				],
				userProps: { columnToDivide: 2 },
			},
		];
	} else if (selectedEigenLeitung === ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal) {
		struc = [
			//Std./Woche lt. Arbeitsvertrag
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Std_Wochelt_Arbeitsvertrag.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Std_Wochelt_Arbeitsvertrag,
						validation: [{ validateFunction: Required }, { validateFunction: GetMinMaxIntValidation, params: [1, 40] }],
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Stundensatz lt. Entgeltgruppe
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe.path,
						label: 'Stundensatz lt. Leistungsgruppe',
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stundensatz_Lt_Entgeltgruppe,
						disabled: true,
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Stellenanteil im Vorhaben (in %)
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stellenanteil_Im_Vorhabenin.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Kreativwirtschaft_Stellenanteil_Im_Vorhabenin,
						validation: [{ validateFunction: Required }, { validateFunction: GetMinMaxDecimalValidation, params: [0, 100] }],
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Einsatzmonate im Vorhaben im Jahr der Bewilligung
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Einsatzmonate_Im_Vorhaben_Im_Jahr_Der_Bewilligung.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Einsatzmonate_Im_Vorhaben_Im_Jahr_Der_Bewilligung,
						validation: [{ validateFunction: Required }, { validateFunction: GetMinMaxIntValidation, params: [1, 12] }],
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Errechnete max. Einsatzstunden im Jahr der Bewilligung
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Errechnete_Max_Einsatzstunden_Im_Jahr_Der_Bewilligung.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Errechnete_Max_Einsatzstunden_Im_Jahr_Der_Bewilligung,
						disabled: true,
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Anzahl der geplanten Stunden im Projekt
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Anzahl_Der_Geplanten_Stunden_Im_Projekt.path,
						tooltip: 'Darf die "Errechnete max. Einsatzstunden im Jahr der Bewilligung" nicht überschreiten.',
						label: 'Anzahl der geplanten Stunden im Projekt',
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Anzahl_Der_Geplanten_Stunden_Im_Projekt,
						validation: [{ validateFunction: GetMaxDecimalValidation, params: [ErrechneteMaxEinsatzstunden] }],
					},
				],
				userProps: { columnToDivide: 2 },
			},
			// Anzahl der geplanten Stunden im Projekt
			{
				fields: [
					{
						type: 'label',
						path: P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
					},
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
						format: 'currency',
						disabled: true,
					},
				],
				userProps: { columnToDivide: 2 },
			},
		];
	}

	return struc;
};

const formStrucFunktionen = (currentKostenPosition: any) => {
	const selectedEigenLeitung = get(
		currentKostenPosition,
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path,
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Funktion_Im_Beantragten_Vorhaben,
				...((
					selectedEigenLeitung === ART_DER_EIGENLEISTUNG.BareEigenleistung ||
					selectedEigenLeitung === ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal
				) ?
					[
						P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Gehoeren_Zu_Den_Taetigken_Fuehrungstaetigkeiten,
					]
				:	[]),
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Taetigkeiten_Im_Vorhaben,
					maxCharLength: 2500,
				},
			],
			userProps: { columnToDivide: 1 },
		},
		...((
			selectedEigenLeitung === ART_DER_EIGENLEISTUNG.BareEigenleistung ||
			selectedEigenLeitung === ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal
		) ?
			[
				{
					fields: [
						P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Berufserfahrung_in_Jahren,
						P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Berufs_Studienabschluss,
					],
				},
				{
					fields: [
						P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Grund_Fuer_Die_Geplante_Funktion_Im_Projekt,
					],
					userProps: { columnToDivide: 1 },
				},
			]
		:	[]),
	];
	return struc;
};
const formStrucUpload = (currentKostenPosition: any) => {
	let struc: FormStrucItem[] = [];

	const selectedEigenLeitung = get(
		currentKostenPosition,
		KP_P.Personalausgaben_Kreativwirtschaft.schema.attributes.Kreativwirtschaft_Art_Der_Eigenleistung.path,
	);
	if (
		selectedEigenLeitung === ART_DER_EIGENLEISTUNG.BareEigenleistung ||
		selectedEigenLeitung === ART_DER_EIGENLEISTUNG.SozialversicherungspflichtigesPersonal
	) {
		struc = [
			{
				fields: [
					{
						...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes
							.Unterschriebene_Funktionsbeschreibung,
						hideLabel: true,
					},
				],
			},
		];
	}

	return struc;
};

const mapPersonalKosten = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};

const customFunktionStruc = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Personalausgaben_Kreativwirtschaft.schema.attributes.Taetigkeiten_Im_Vorhaben,
					validation: [{ validateFunction: GetTextboxValidation(2500), onlyValidateOnNonEmptyValue: true }],
					maxCharLength: 2500,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucPersonalkostenAntragKreativwirtschaft = (application: any, unternehmenId: number) => {
	let result: FormStrucItem[] = [];

	get(application, P.Foerderantrag_Kostenpositions.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);

			const formStrucSpalte1KategorieWithIndex = mapPersonalKosten(formStrucSpalte1Kategorie(), i);
			const formStrucSpalte1WithIndex = mapPersonalKosten(formStrucKalkulationSpalte1(ele), i);
			const formStrucSpalte2PersonWithIndex = mapPersonalKosten(formStrucSpalte2Person(), i);
			const formStrucSpalte2WithIndex = mapPersonalKosten(formStrucKalkulationSpalte2(ele, i), i);
			const formStrucCustomFunktionWithIndex = mapPersonalKosten(customFunktionStruc(), i);
			const formStrucUploadWithIndex = mapPersonalKosten(formStrucUpload(ele), i);

			if (isHinweisFieldRequired) {
				result = concat(
					mapPersonalKosten(PruefAssistenzStruc(), i),
					result,
					formStrucSpalte1KategorieWithIndex,
					formStrucSpalte1WithIndex,
					formStrucSpalte2PersonWithIndex,
					formStrucSpalte2WithIndex,
					formStrucCustomFunktionWithIndex,
					formStrucUploadWithIndex,
				);
			} else {
				result = concat(
					result,
					formStrucSpalte1KategorieWithIndex,
					formStrucSpalte1WithIndex,
					formStrucSpalte2PersonWithIndex,
					formStrucSpalte2WithIndex,
					formStrucCustomFunktionWithIndex,
					formStrucUploadWithIndex,
				);
			}
		}
	});

	return result;
};
